<title>{{title}}</title>
<link rel="icon" id ="favIcon" type="image/x-icon" href="favicon.ico">

<ng-template [ngIf]="isLoad">
  <div class="main-page">

    <!-- barre de navigation -->
    <div class="col-12 no-padding" [ngClass]="currentTheme">
      <app-header (menuEmit)="toggleSideNav($event)">
      </app-header>
    </div>

 

    <mat-sidenav-container class="example-container row no-padding" (backdropClick)="sidenav.close()"
      [ngClass]="currentTheme">

      <!-- barre de navigation a gauche -->
      <mat-sidenav [ngClass]="currentTheme" #sidenav (keydown.escape)="sidenav.close()" fixedInViewport=true
        from="right" disableClos style="top: 85px !important;">
        <app-sidenav-content (close)="closeSideNav($event)"></app-sidenav-content>
      </mat-sidenav>

      <!-- le contenu  -->

     


      <mat-sidenav-content class="col-12 no-padding  full-hight page-main-content">
        <div class="row no-padding  full-hight" [ngClass]="currentTheme">
          <div class="col-12 full-hight router-data">
            <router-outlet></router-outlet>
          </div>
        </div>


      


        <div class="col-12 footer">
          <app-main-footer></app-main-footer>
        </div>
      </mat-sidenav-content>


    </mat-sidenav-container>
  </div>
</ng-template>

